import { createFileRoute } from '@tanstack/react-router'
import { AdminBrands } from '../features/admin'
import { brandsQuery } from '../features/admin/brands/api'
import { adminRouteState } from '../features/admin/route-state'

export const Route = createFileRoute('/admin/brands')({
  ...adminRouteState,
  loader: ({ context }) => context.queryClient.ensureQueryData(brandsQuery()),
  component: AdminBrands,
})
